import { useQuery } from "@tanstack/react-query";
import { useApp } from "./use-app";
import { useEffect, useMemo } from "react";
import dayjs from "dayjs";
import { axios } from "lib/axios";
import { navigate } from "wouter/use-location";

const useMaintenance = () => {
  const { app } = useApp()
  const { data, isLoading } = useQuery<{
    result: 'maintenance' | 'ok';
    retry_after: string;
  }>({
    queryKey: ["app-status"],
    queryFn: () =>
      axios
        .get(`app-health/${app.id}`)
        .then((res) => res.data),
  });

  const formattedRetryAfter = useMemo(() => {
    if (!data?.retry_after) return ''
    return dayjs(data.retry_after).format('dddd D MMMM, HH:mma [GMT]Z')
  }, [data])

  useEffect(() => {
    if (isLoading || !data) return
    // When in maintenance page
    if (location.pathname.includes('maintenance')) {
      if (data.result === 'ok') {
        window.location.href = app.appUrl
      }
    // When in login page
    } else if (data.result === 'maintenance') {
      navigate('/maintenance')
    }
  }, [isLoading])

  return { data, isLoading, retryAfter: formattedRetryAfter, app }
}

export default useMaintenance
